<template>
    <div class="chat__body" ref="container">
        <div v-if="!messages.length" class="chat__start-message">
            <strong class="r-strong">Здесь будет показана история сообщений</strong>
        </div>
        <message :message="message" v-for="message in messages" :key="message.id"></message>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    import Message from "./Message.vue";

    export default {
        components: {Message},
        name: 'Messages',
        computed: {
            ...mapState('chat', [
                'messages',
            ]),
            ...mapState([
                'consultation',
                'echoServices'
            ]),
            qty() {
                return this.messages.length;
            }
        },
        watch: {
            qty() {
                this.$nextTick(() => {
                    this.$refs.container.scrollTop = this.$refs.container.scrollHeight;
                });
            }
        },
        mounted() {
            window.echo.private('consultation.room.'+ this.consultation.id).listen('Chat', ({message}) => {
                this.addMessage(message);
            });

            this.getMessages();
        },
        methods: {
            ...mapActions('chat', [
                'getMessages',
            ]),
            ...mapMutations('chat', [
                'addMessage',
            ])
        }
    }
</script>
